import React from "react";

import { Button } from "components";

import UserDetailsDashboard from "pages/usuarios/UserDetailsDashboard";

export default function DetailModal({
    usuarioId, closeModal, service
}) {
    return (
        <>
            <UserDetailsDashboard usuarioId={usuarioId} service={service} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={"button"}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>

        </>
    );
}
